import { render, staticRenderFns } from "./Advertisers_Management.vue?vue&type=template&id=04c555a0&scoped=true&"
import script from "./Advertisers_Management.vue?vue&type=script&lang=js&"
export * from "./Advertisers_Management.vue?vue&type=script&lang=js&"
import style0 from "./Advertisers_Management.vue?vue&type=style&index=0&id=04c555a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c555a0",
  null
  
)

export default component.exports